import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import {
  HA_OKTA_AUTHORIZE_URIS,
  HA_OKTA_TOKEN_URL,
  OKTA_AUTHORIZE_URIS,
  OKTA_CLIENT_ID,
  OKTA_ISSUER,
  OKTA_LOG_OFF,
  OKTA_TOKEN_URL,
  URL_ROUTES,
  API_ENV,
} from '../../adapters/constants';

import { OktaVariables } from './types';

export const oktaVariables: OktaVariables = {
  issuer: OKTA_ISSUER[API_ENV],
  clientId: OKTA_CLIENT_ID[API_ENV],
  redirectUri: `${window.location.origin}`,
  authorizeUrl: OKTA_AUTHORIZE_URIS[API_ENV],
  tokenUrl: OKTA_TOKEN_URL[API_ENV],
  logoutBaseUrl: OKTA_LOG_OFF[API_ENV],
};

export const haOktaVariables: OktaVariables = {
  issuer: OKTA_ISSUER[API_ENV],
  clientId: OKTA_CLIENT_ID[API_ENV],
  redirectUri: `${window.location.origin}`,
  authorizeUrl: HA_OKTA_AUTHORIZE_URIS[API_ENV],
  tokenUrl: HA_OKTA_TOKEN_URL[API_ENV],
  logoutBaseUrl: OKTA_LOG_OFF[API_ENV],
};

export const restoreOriginalUri = (
  _oktaAuth: OktaAuth,
  originalUri: string,
): void => {
  const url = toRelativeUrl(
    originalUri || URL_ROUTES.landingPage,
    window.location.origin,
  );
  window.location.replace(url);
};
